import React, { useState } from "react";
import styled from "@emotion/styled";
import ImgTraining from "../assets/images/CNC-Training.jpg";
import ImageTitle from "../components/ImageTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const trainingImages = [
  "/pdf/paso 1.png",
  "/pdf/paso 2.png",
  "/pdf/paso 3.png",
  "/pdf/paso 4.png",
  "/pdf/paso 5.png",
  "/pdf/paso 6.png",
  "/pdf/paso 7.png",
];

const Training = () => {
  const TrainingDiv = styled.div`
    background: #ededed;
    padding-bottom: 25px;
  `;

  const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    padding: 20px;
    margin: 0px 50px;
    text-align: center;
    width: 70%;
    margin: auto;
  `;

  const ButtonText = styled.p`
    font-family: "DM Sans", serif;
    color: white;
    font-size: 20px;
    font-weight: 700;
  `;

  const [activePage, setActivePage] = useState(1);

  const handleNext = () => setActivePage((prev) => Math.min(prev + 1, trainingImages.length));
  const handleBack = () => setActivePage((prev) => Math.max(prev - 1, 1));

  return (
    <TrainingDiv>
      <ImageTitle
        title="PLATAFORMA DIGITAL"
        subtitle="CAPACITACIÓN CUANDO Y DÓNDE QUIERAS"
        image={ImgTraining}
      />

      <Descripcion>
        Siguiendo el avance tecnológico y las necesidades de nuestros asociados, y en línea con
        nuestra transformación digital, desde octubre de 2025 hemos implementado la capacitación
        híbrida en programas formativos avalados por la{" "}
        <strong>Coordinación Nacional de Capacitación.</strong>
        <br /><br />
        Hemos desarrollado esta plataforma para dejar de depender de sistemas académicos externos,
        contando ahora con nuestro propio <strong>Academic Workflow Engine</strong>, una solución
        integral que gestiona programas jerárquicos, evaluación teórico-práctica, recuperación
        mediante extraordinarios, y trazabilidad institucional completa.
        <strong>
          {" "}Ahora puedes acceder a formación de alta calidad desde cualquier lugar, con la
          flexibilidad que necesitas. Entre nuestros programas destacados, ofrecemos el{" "}
        </strong>
        Programa Nacional de Formación como Técnico en Urgencias Médicas Nivel Básico en Modalidad
        Híbrida, permitiendo combinar el aprendizaje en línea con prácticas presenciales esenciales.
        <br /><br />
        Contamos con cobertura nacional a través de Coordinadores Estatales en 31 estados,
        Facilitadores y Coordinadores de Grupo para programas especiales, y miles de voluntarios
        activos en formación continua.
        <br /><br />
        Las fechas y detalles de inscripción serán compartidos por las Coordinaciones Estatales y
        Locales de Capacitación a través de la plataforma.
        <br /><br />
        <strong>¿Ya eres participante?</strong>
      </Descripcion>

      {/* Botón de acceso */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#d31414",
            color: "white",
            borderRadius: "30px",
            "&:hover": { color: "white", backgroundColor: "#0d6834" },
            padding: "30px 30px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          onClick={() => window.open("https://soyvoluntario.cruzrojamexicana.org.mx/", "_blank")}
        >
          <ButtonText>ACCEDE A #SoyVoluntario</ButtonText>
          <FaArrowRight color="white" size={30} />
        </Button>
      </Box>

      {/* Carrusel */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: 900, mx: "auto", mt: 6, px: 2 }}>
        <Box sx={{
          background: "white",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          overflow: "hidden",
          width: "90%",
          maxWidth: 680,
        }}>
          {/* Header */}
          <Box sx={{
            background: "#d31414",
            padding: "12px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <Box sx={{ fontFamily: "DM Sans", color: "white", fontSize: 15, letterSpacing: 1 }}>
              📋 CATÁLOGO DE INDICACIONES
            </Box>
            <Box sx={{
              fontFamily: "DM Sans", fontSize: 13, color: "rgba(255,255,255,0.85)",
              background: "rgba(255,255,255,0.2)", border: "1px solid rgba(255,255,255,0.4)",
              borderRadius: "8px", padding: "4px 12px",
            }}>
              {activePage} / {trainingImages.length}
            </Box>
          </Box>

          {/* Imagen */}
          <Box sx={{ position: "relative", width: "100%", background: "#111", aspectRatio: "16/9" }}>
            <img
              src={trainingImages[activePage - 1]}
              alt={`Paso ${activePage}`}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            <IconButton
              onClick={handleBack}
              disabled={activePage <= 1}
              sx={{
                position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
                background: "rgba(0,0,0,0.45)", color: "white", zIndex: 10,
                "&:hover": { background: "rgba(211,20,20,0.75)" },
                "&.Mui-disabled": { opacity: 0.3, color: "white" },
              }}
            >
              <FaChevronLeft />
            </IconButton>
            <IconButton
              onClick={handleNext}
              disabled={activePage >= trainingImages.length}
              sx={{
                position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                background: "rgba(0,0,0,0.45)", color: "white", zIndex: 10,
                "&:hover": { background: "rgba(211,20,20,0.75)" },
                "&.Mui-disabled": { opacity: 0.3, color: "white" },
              }}
            >
              <FaChevronRight />
            </IconButton>
          </Box>

          {/* Footer dots */}
          <Box sx={{ background: "#f9f9f9", borderTop: "1px solid #e0e0e0", padding: "12px 20px", display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
            <Box sx={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
              {trainingImages.map((_, i) => (
                <Box
                  key={i}
                  onClick={() => setActivePage(i + 1)}
                  sx={{
                    width: activePage === i + 1 ? "20px" : "8px",
                    height: "8px",
                    borderRadius: "4px",
                    background: activePage === i + 1 ? "#d31414" : "#ccc",
                    cursor: "pointer",
                    transition: "width 0.3s ease, background 0.3s ease",
                  }}
                />
              ))}
            </Box>
            <Box sx={{ fontFamily: "DM Sans", fontSize: 12, color: "#888" }}>
              Coordinación Nacional de Capacitación · Cruz Roja Mexicana
            </Box>
          </Box>
        </Box>
      </Box>
    </TrainingDiv>
  );
};

export default Training;